export const deClientPortalMarketDataPages = {
    marketData: {
        explorer: {
            title: 'Analyse',
            demoLabel: 'DEMO',
            demoTooltip: 'Für diese Demo stellen wir ausschließlich Musterdaten zur Verfügung',
        },
        demoCity: 'Musterstadt',
        unitPrefix: 'in {{unit}}',
        noSelection: {
            selectAssetOrCustomLocation: 'Wählen Sie eine Immobilie oder einen individuellen Standort über die Adresssuche.',
            selectAsset: 'Wählen Sie eine Immobilie, um die Marktdaten anzuzeigen.',
        },
        noData: {
            lineOne: 'Zu Ihrer Auswahl können leider keine Daten angezeigt werden.',
            lineTwo: 'Bitte versuchen Sie es später erneut.',
            imageAlt: 'Platzhalter für fehlende Daten',
        },
        sidebar: {
            title: 'Auswahl',
            customLocation: 'Individueller Standort',
            emptyText: 'Hier können Sie Immobilien auswählen, sobald ein entsprechendes Gutachten abgeschlossen ist.',
        },
        search: {
            title: 'Individueller Standort',
            coordinateError: 'Für diese Suche konnten keine Koordinaten geladen werden.',
            cancel: 'Abbrechen',
            next: 'Weiter',
            googleSearchBar: {
                noMatchingAddress: 'Keine passende Adresse gefunden',
                enterAddressToShowOptions: 'Adresse angeben, um Optionen anzuzeigen',
                consentRequiredLabel: 'Zum Benutzen der Adresssuche müssen Sie Google Maps zulassen',
                searchLabel: 'Adresse suchen',
            },
        },
        sidebarSelection: {
            marketValue: 'Verkehrswert',
            marketRent: 'Marktmiete',
            managementCosts: 'Bewirtschaftungskosten',
            grossYield: 'Yield (Bruttorendite)',
        },
        stats: {
            maximum: 'Maximum',
            average: 'Durchschnitt',
            minimum: 'Minimum',
        },
        categories: {
            apartments: 'Wohnungen',
            houses: 'Häuser',
            office: 'Büro',
            retail: 'Einzelhandel',
            logistics: 'Logistik',
            other: 'Mehr',
        },
        topics: {
            price_apartment_new: 'Kaufpreis Eigentumswohnung Erstbezug',
            price_apartment_existing: 'Kaufpreis Eigentumswohnung Bestand',
            rent_apartment_new: 'Miete Erstbezug',
            rent_apartment_existing: 'Miete Bestand',
            price_plot_single_family_house: 'Kaufpreis EFH Grundstück',
            price_single_family_house: 'Kaufpreis Einfamilienhaus',
            price_townhouse_new: 'Kaufpreis Reihenhaus Erstbezug',
            price_townhouse_existing: 'Kaufpreis Reihenhaus Bestand',
            retail_rent_city: 'Miete Einzelhandel in 1a-Lagen',
            retail_rent_1b: 'Miete Einzelhandel in 1b-Lagen',
            retail_yield_central: 'Nettoanfangsrendite Einzelhandel zentrale Lagen',
            retail_yield_decentral: 'Nettoanfangsrendite Einzelhandel dezentrale Lagen',
            office_rent_city: 'Miete Büro City',
            office_rent_fringe: 'Miete Büro City-Rand',
            office_rent_suburb: 'Miete Büro Peripherie',
            office_rent_agglomeration: 'Miete Bürozentren',
            logistics_rent_logistics: 'Miete Logistik- und Lagerflächen',
            logistics_rent_service: 'Miete Serviceflächen',
            logistics_yield_logistics: 'Nettoanfangsrendite Lagerhallen',
            logistics_yield_industrial: 'Nettoanfangsrendite Industrieflächen',
            logistics_yield_logistics_prime: 'Nettoanfangsrendite Lagerhallen, Spitzenrendite',
            logistics_yield_industrial_prime: 'Nettoanfangsrendite Industrieflächen, Spitzenrendite',
            area: 'Fläche',
            gross_domestic_product: 'Bruttoinlandsprodukt',
            gross_domestic_product_ranking: 'Bruttoinlandsprodukt Ranking',
            employment: 'Beschäftigung',
            unemployment: 'Arbeitslosenquote',
            unemployment_ranking: 'Arbeitslosenquote Ranking',
            population: 'Einwohnerzahl',
            building_permit_apartments: 'Baugenehmigungen',
            population_density: 'Einwohnerdichte',
            population_ranking: 'Einwohnerzahl Ranking',
            retail_rent_secondary: 'Miete Einzelhandel Stadtteillagen',
            office_yield_decentral: 'Nettoanfangsrendite Büro dezentrale Lagen',
            office_yield_central: 'Nettoanfangsrendite Büro zentrale Lagen',
        },
        descriptions: {
            marketValue: 'Marktwert in €',
            marketValuePerArea: 'Marktwert in €/m² {{areaLabel}}',
            landValuePerArea: 'Bodenwert in €/m² Grundstücksfläche',
            monthlyMarketRentPerArea: 'Monatliche Marktmiete in €/m² {{areaLabel}}',
            rentableArea: 'vermietbare Fläche',
            livingArea: 'Wohnfläche',
            usableArea: 'Nutzfläche',
        },
    },
}
